import { render, staticRenderFns } from "./ZoomSlider.vue?vue&type=template&id=6a4912f7&"
import script from "./ZoomSlider.vue?vue&type=script&lang=js&"
export * from "./ZoomSlider.vue?vue&type=script&lang=js&"
import style0 from "./ZoomSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports